import React, { useRef } from 'react';
import { Typography } from '@mui/material';

import { ResponsiveBreak, StepPanelHeader } from '../../../../../components';
import { useEmojisplosion } from '../../../../../hooks';
import startImage from '../../../../../assets/passing-star.png';
import LetsConnect from '../../../../letsConnect/LetsConnect';

// PLP-2516: candidate cleared the standard test task score but no open position matches their score yet.
// They are parked as "TT Passed: Below Target" and recontacted when a suitable position opens.
const TestTaskBelowTargetMessage = () => {
  const starRef = useRef<HTMLDivElement>(null);
  useEmojisplosion(starRef, 'TT_PASSED');

  return (
    <>
      <StepPanelHeader
        ref={starRef}
        srcSetPng={startImage}
        alt="Star"
        data-testid="test-task-below-target-title"
      >
        Thank you <ResponsiveBreak breakpoint="sm" />
        for your application!
      </StepPanelHeader>
      <Typography
        variant="body1"
        mb={0}
        data-testid="test-task-below-target-text"
      >
        Your skills and experience look really good. While we don’t have an
        immediate opening that’s the right next step for you right now, we don’t
        want to lose touch — we’ll reach out the moment a better-suited
        opportunity opens up.
      </Typography>
      <LetsConnect justifyContent={{ xs: 'flex-start', sm: 'center' }} />
    </>
  );
};

export default TestTaskBelowTargetMessage;
